export const INGREDIENT_TYPES = {
    PRODUCE : 0,
    VIDEO: 1,
    AUDIO: 2,
    DETECT: 3,
    GENERATE: 4,
    AR: 5,
    QUIZZING: 6
}